// extracted by mini-css-extract-plugin
export default {"container":"GiftCardAmount_container__N2AYu","customAmount":"GiftCardAmount_customAmount__S4GNO","valid":"GiftCardAmount_valid__5MQrD","invalid":"GiftCardAmount_invalid__BZB8-"};